import {
	useGetSpace,
	useListSpaces,
} from '@cocoonspace/sdk-js/domains/spaces/spaces'
import type { Space } from '@cocoonspace/sdk-js/types/space'
import type { Zone } from '@cocoonspace/sdk-js/types/zone'
import { searchConfig } from '@cocoonspace/shared/config/search-config'
import { useMemo } from 'react'

export const useSpaceDetailsPage = (spaceId: Space['id'] | Space['slug']) => {
	const spaceDetailsQuery = useGetSpace(spaceId, undefined, {
		query: {
			keepPreviousData: true,
			select: (space) => space.data,
		},
	})

	const district = useMemo(() => {
		const zone = (spaceDetailsQuery.data?.zone as Zone) || 'paris'

		return searchConfig.districts[zone]?.find(
			(district) =>
				district.zip === spaceDetailsQuery.data?.address.postal_code,
		)
	}, [
		spaceDetailsQuery.data?.zone,
		spaceDetailsQuery.data?.address.postal_code,
	])

	const suggestionsQuery = useListSpaces(
		{
			limit: 6,
			zone: spaceDetailsQuery.data?.zone as Zone,
			latitude: district?.latitude,
			longitude: district?.longitude,
			capacity: `${Math.max((spaceDetailsQuery.data?.capacity ?? 0) - 2, 0)}-${
				(spaceDetailsQuery.data?.capacity ?? 0) + 2
			}`,
		},
		{
			query: {
				keepPreviousData: true,
				enabled: !!spaceDetailsQuery.data && !!district,
				select: (spaces) => spaces.data,
			},
		},
	)

	return {
		spaceDetailsQuery,
		suggestionsQuery,
		district,
	}
}
